import { useQueryClient } from '@tanstack/react-query';
import { useNavigate } from 'react-router-dom';

import { RedirectSingleton, RedirectType } from '@pkg/classes';
import { AuthNewLocalStorage } from '@pkg/components';
import { useAppDispatch, useLogin } from '@pkg/hooks';
import { LocalStorageKeys } from '@pkg/types';
import { removeLocalStorageItems } from '@pkg/utils';

import { apiFactory } from '@app/client';
import { APP_ANONYMOUS_LANDING_PAGE } from '@app/routes/paths';
import { clearUser } from '@app/store/actions/user';

import { flushTokens } from './utilities';

export function useLogout() {
    const dispatch = useAppDispatch();
    const queryClient = useQueryClient();
    const navigate = useNavigate();
    const { sanitizeStorage } = useLogin();

    function clearSession() {
        apiFactory().disconnectWebsocket();
        removeLocalStorageItems([
            LocalStorageKeys.FirstTimeUserExperience,
            LocalStorageKeys.EmojiIds,
            AuthNewLocalStorage.OAuthLoggedIn,
        ]);
        localStorage.setItem(LocalStorageKeys.RemoveDraftUser, '0');
    }

    function logout({ redirectPath }: { redirectPath?: string | null } = {}) {
        clearSession();
        dispatch(clearUser());

        sanitizeStorage();
        flushTokens();

        if (redirectPath) {
            RedirectSingleton.setRedirect(RedirectType.Default, redirectPath);
        }

        void queryClient.invalidateQueries();
        navigate(APP_ANONYMOUS_LANDING_PAGE);
    }

    return {
        logout,
    };
}
